import React from 'react'
import PropTypes from 'prop-types'
import useTheme from './hooks/use-theme'
import { observer } from 'mobx-react'
import * as Icons from 'ui/icons'

function ThemeSwitcher (props) {
  const { type } = props
  const theme = useTheme()

  const switchTheme = () => {
    theme.set(type)
  }

  const classNames = () => {
    return [
      theme.get() === type ? 'active' : null
    ].filter(e => e).join(' ')
  }

  const themeIcon = type => {
    switch (type) {
      case 'list':
        return <Icons.SortList className='w-4 h-4 block' />
      case 'calendar':
        return <Icons.SortCalendar className='w-4 h-4 block' />
      case 'staff':
        return <Icons.User className='w-4 h-4 block' />
      default:
        return type
    }
  }

  return (
    <button type='button' className={classNames(type)} onClick={switchTheme}>
      {props.label || themeIcon(type)}
    </button>
  )
}

export default observer(ThemeSwitcher)

ThemeSwitcher.defaultProps = {
  label: null,
  type: null
}

ThemeSwitcher.propTypes = {
  label: PropTypes.node,
  type: PropTypes.string.isRequired
}
